<!-- 由 suu 创建于 2022-06-22 Wednesday -->
<template>
  <div class="recipe-cna-start" v-if="number">
    <!-- 头部图片 -->
    <img
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-start-bg"
      alt=""
      class="cna-top"
    />
    <!-- logo -->
    <img
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
      alt=""
      class="cna-logo"
    />
    <div class="cna-desc">
      我们已为 <span>{{ number }}人</span> 定制营养方案
    </div>
    <!-- 轮播 -->
    <van-swipe class="cna-swipe" :autoplay="2000" indicator-color="#6759FF">
      <van-swipe-item v-for="(item, index) in imgs" :key="index">
        <img class="cna-img" :src="item" alt="" />
      </van-swipe-item>
    </van-swipe>
    <!-- 按钮 -->
    <div class="cna-btn user-btn" @click="handelStart">开始评估</div>
  </div>
</template>

<script>
import '@/assets/font/font.css'
export default {
  name: 'recipe-cna-start',

  components: {},

  props: {},

  data() {
    return {
      number: 0,
      imgs: [
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-start-img1',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-start-img2',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-start-img3',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-start-img4',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-start-img5'
      ]
    }
  },

  computed: {
    id() {
      return this.$route.query.rid || this.$route.query.id
    }
  },

  watch: {},

  created() {
    this.getInfo()
  },

  mounted() {},

  destroyed() {},

  methods: {
    handelStart() {
      this.$router.push('/recipe-cna-notice?id=' + this.id)
    },
    // 获取报告数
    getInfo() {
      this.$http
        .getBaseApp('member/AppCamp/getPosterNum', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.number = res.data
          }
        })
        .catch(() => {
          // this.$toast.clear()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.recipe-cna-start {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  z-index: 1;
  background-color: #fbfbfb;
  display: flex;
  flex-direction: column;
  align-items: center;
  @include paddingBottom(46px);
  .cna-top {
    width: 100%;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .cna-logo {
    width: 99px;
    position: absolute;
    left: 32px;
    top: 10px;
  }
  .cna-desc {
    margin-top: 213px;
    font-size: 12px;
    font-weight: 500;
    color: #697387;
    span {
      font-size: 15px;
      font-weight: bold;
      font-size: DIN;
      color: #6759ff;
    }
  }
  .cna-swipe {
    width: 335px;
    height: 412px;
    box-sizing: border-box;
    margin-top: 12px;
    border-radius: 12px;
    .cna-img {
      width: 100%;
      box-shadow: 0px 6px 11px 0px rgba(54, 61, 84, 0.03);
    }
    &::v-deep {
      .van-swipe__indicator {
        background: #e2e3ea;
      }
      .van-swipe__indicator--active {
        width: 12px;
        border-radius: 3px;
      }
    }
  }
  .cna-btn {
    width: 215px;
    height: 50px;
    background: #6759ff;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 600;
    color: #ffffff;
    margin-top: 10px;
  }
}
</style>
